<template>
  <!-- 核心技术 -->
  <div class="core-technology_container">
    <div class="top-img_container">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <NavTools :displaySecNav="false"></NavTools>
    <router-view></router-view>
  </div>
</template>

<script>
  import DragCarousel from '@/components/drag-carousel/index.vue'
  import NavTools from '@/layouts/components/NavTools.vue'

  export default {
    components: { NavTools, DragCarousel },
    data() {
      return {
        imgData: [
          {
            src: require('@/assets/img/coreTechnology/technology.jpg'),
            alt: '核心技术'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  .solution_wrap {
    width: 100%;
    height: 100%;
  }
  .top-img_container {
    margin-top: 80px;
    @media screen and (max-width: 768px) {
      margin: 0;
    }
  }
</style>
